module.exports = __webpack_public_path__ + "img/voucher6.b4ee057f.png";